import _ from 'lodash';
import moment from 'moment';
export function dateToEpoch(date) {
  return moment(date).utc().unix();
}
export function epochToDate(epoch) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'M/D/YYYY';
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!_.isNil(epoch)) {
    return moment.unix(epoch).utcOffset(offset).format(format);
  }
  return '';
}
//# sourceMappingURL=epoch.js.map